import * as React from "react";
import styled from "styled-components";

import { BaseModal } from "Components/Modal/BaseModal";
import { CancelButton } from "Globals/Styles/Control/Buttons";
import { useObserver } from "mobx-react-lite";
import { EditContactModalDialogPaper } from "Views/Contacts/EditContactModal.styles";
import { ProcessedRequisitionRequestInvoiceItem } from "../../PurchaseOrderModel";

interface ILineValidationModalProps {
    open?: boolean;
    onClose(): void;
    title: string;
    lineValidationItems: ProcessedRequisitionRequestInvoiceItem[];
    isLoading: boolean;
}

// May want separate component for PurchaseOrders and Invoices.
export const LineValidationModal: React.FunctionComponent<ILineValidationModalProps> = ({ open, onClose, title, lineValidationItems, isLoading }) => {
    const renderBody = () => {
        return (
            <>
                <div>You can't save these changes as the following items have already been allocated to an invoice:</div>
                <ul style={{ paddingLeft: "20px" }}>
                    {lineValidationItems.map((item: ProcessedRequisitionRequestInvoiceItem, index: number) => {
                        return (
                            <li>
                                {item.lineDisplayName} - {item.itemDescription}
                            </li>
                        );
                    })}
                </ul>
            </>
        );
    };

    return useObserver(() => (
        <BaseModal
            open={open}
            onClose={onClose}
            title={title}
            PaperComponent={(props) => <LineValidationModalDialogPaper {...props} />}
            actions={
                <>
                    <CancelButton onClick={onClose}>Close</CancelButton>
                </>
            }
        >
            <LineValidationContainer>{renderBody()}</LineValidationContainer>
        </BaseModal>
    ));
};

export const LineValidationModalDialogPaper = styled(EditContactModalDialogPaper)`
    width: 100% !important;
    max-width: 1000px;
    max-width: "1000px";

    .MuiDialogActions-root > button {
        max-width: 262px;
    }

    .MuiDialogContent-root {
        margin-bottom: 20px;
    }

    .MuiDivider-root {
        background-color: rgba(0, 0, 0, 0.12) !important;
    }
`;

const LineValidationContainer = styled.div``;
